<div class="row mt-3">
  <div class="col-sm-10">
    <div class="input-group adv-search justify-content-end align-items-center">
      <div class="d-flex justify-content-center align-items-center m-0">
        <p *ngIf="from && to" class="vid-label-sm me-2 mb-0">
          {{from | isoDate}} - {{to | isoDate}}</p>
        <img class="vid-nav-icon me-3 action w-35" alt="" (bsValueChange)="dateChangedEvent($event)"
             [bsConfig]="{ isAnimated: false, containerClass:'theme-default', ranges: ranges, displayOneMonthRange: false, value: startDateRange, dateInputFormat: 'YYYY-MM-DD' }"
             [maxDate]="maxDate" placement="bottom" bsDaterangepicker src="assets/icons/calendar.png"/>
      </div>

      <button class="vid-btn vid-btn-sm ms-2" (click)="onSubmitSimpleSearch()">{{'ACTIVITY.SEARCH_BUTTON' | translate }}</button>
    </div>
  </div>
  <div class="col-sm-10">
    <div class="vid-main-content">
      <div class="row mb-4">
        <div class="col-sm-12">
          <div class="list-group list-group-flush">
            <div *ngIf="data?.length == 0" class="list-group-item list-group-item-action">
              <div class="flex-column justify-content-between align-items-center">
                <div class="d-flex w-100 justify-content-between">
                  <span class="w-100 text-center">{{'ACTIVITY.NO_DATA_FOR_INTERVAL_ERROR' | translate }}</span>
                </div>
              </div>
            </div>
            <accordion *ngIf="!isLoading">
              <accordion-group #accordionGroup *ngFor="let item of data; index as i"
                               class="accordion-container list-group-item list-group-item-action col-sm-12"
                               [isOpen]="accordionExpanded[i]"
                               (isOpenChange)="openedSessionDetails(item, i)" panelClass="sessions-accordion-panel">
                <div class="row" accordion-heading>
                  <div class="col-sm-2">
                      <span class="vid-list-item-title">
                        {{item.requestTime | isoDateTime}}
                      </span>
                  </div>
                  <div class="col-sm-2">
                    <span class="vid-list-item-title">{{item.serviceFriendlyName || item.application}}</span>
                  </div>
                  <div class="col-sm-2">
                    <span class="vid-list-item-title">{{item.location.locationMap['location']}}</span>
                  </div>
                  <div class="col-sm-2">
                    <div *ngIf="item.authenticationMode == 'SPNEGO'">
                        <span class="vid-badge badge bg-primary me-2">{{'AUTHENTICATORS.SPNEGO' | translate }}</span>
                    </div>

                    <div *ngIf="item.authenticationMode != 'SPNEGO' && item.authenticatorsDetails">
                        <span *ngFor="let auth of item.authenticatorsDetails.slice().reverse()"
                              class="me-2">
                            <span *ngIf="auth.type != 'DESKTOP_FACE'">
                                <span *ngIf="auth.status"
                                      class="vid-badge badge bg-success me-2">{{
                                  'AUTHENTICATORS.' + auth.type | translate }}</span>
                                <span *ngIf="!auth.status"
                                      class="vid-badge badge bg-secondary me-2">{{
                                  'AUTHENTICATORS.' + auth.type | translate }}</span>
                            </span>
                        </span>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <span *ngIf="item.status==='COMPLETED'"
                          class="vid-badge badge bg-success">{{'SESSION.COMPLETED' | translate }}
                    </span>
                    <span *ngIf="item.status==='FAILED'"
                          class="vid-badge badge bg-danger">{{'SESSION.FAILED' | translate }}
                    </span>
                    <span *ngIf="item.status==='TIMEOUT'"
                          class="vid-badge badge bg-warning text-dark">{{'SESSION.TIMEOUT' | translate }}
                    </span>
                    <span *ngIf="item.status==='CANCELED'"
                          class="vid-badge badge bg-secondary">{{'SESSION.CANCELED' | translate }}
                    </span>
                  </div>

                  <div class="col-sm-1 text-end">
                    <span>
                        <fa-icon *ngIf="accordionGroup.isOpen" icon="chevron-up"
                                 class="vid-fa-icon-black m-1"></fa-icon>
                        <fa-icon *ngIf="!accordionGroup.isOpen" icon="chevron-down"
                                 class="vid-fa-icon-black m-1"></fa-icon>
                    </span>
                  </div>
                </div>
                <div class="sessions-accordion-content">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="vid-small-label">{{getSession(item?.id)?.locationSource }}{{ ' ' }}{{'ACTIVITY.LOCATION_SOURCE' | translate}}:</div>
                      <div class="vid-card-value mt-1">
                        <span>{{getSession(item?.id)?.location.locationMap['location']}}</span>
                      </div>

                      <div *ngIf="getSession(item?.id)?.location?.errorCode != 0">
                        <div class="vid-small-label">{{'ACTIVITY.LOCATION_ERROR_TITLE' | translate }}:</div>
                        <div class="vid-card-value mt-1">
                          <span *ngIf="getSession(item?.id)?.location?.errorCode == 1053"
                                class="vid-badge badge bg-warning text-dark">{{'LOCATION_ERROR.FAILED_GEOCODE' | translate}}
                          </span>
                          <span *ngIf="getSession(item?.id)?.location?.errorCode == 1054"
                                class="vid-badge badge bg-warning text-dark">{{'LOCATION_ERROR.LOCATION_SERVICES_UNAVAILABLE' | translate}}
                          </span>
                          <span *ngIf="getSession(item?.id)?.location?.errorCode == 1055"
                                class="vid-badge badge bg-warning text-dark">{{'LOCATION_ERROR.LOCATION_PERMISSION_DENIED' | translate}}</span>
                          <span *ngIf="getSession(item?.id)?.location?.errorCode == 1056"
                                class="vid-badge badge bg-warning text-dark">{{'LOCATION_ERROR.TIMEOUT' | translate}}</span>

                          <span *ngIf="getSession(item?.id)?.location?.errorCode == 1073"
                                class="vid-badge badge bg-warning text-dark">{{'LOCATION_ERROR.TIMEOUT' | translate}}</span>
                        </div>
                      </div>
                      <div class="map-frame" *ngIf="showMap">
                        <div id="map_{{i}}" class="h-100 mt-2"></div>
                        <div class="vid-small-label overlay" *ngIf="!this.sessionLocationMapAvailable[i]">
                          <span>
                            <img
                              alt=""
                              src='assets/icons/hide.png' width="15" height="15">
                            {{'ACTIVITY.LOCATION_NOT_AVAILABLE_ERROR' | translate }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="getSession(item?.id) as sessionModel">
                      <div class="col-sm-3">
                        <div class="vid-small-label">{{"ACTIVITY.SESSION_ID_TITLE" | translate}}:</div>
                        <div class="vid-card-value mt-1">
                          <span>{{item?.id}}</span>
                        </div>
                        <div class="vid-small-label">{{"ACTIVITY.IDENTITY_TITLE" | translate}}:</div>
                        <div class="vid-card-value mt-1">
                          <span>{{sessionModel?.identity}}</span>
                        </div>

                        <div class="vid-small-label">{{"ACTIVITY.UPN_TITLE" | translate}}:</div>
                        <div class="vid-card-value mt-1">
                          <span>{{sessionModel?.upn}}</span>
                        </div>
                        <div *ngIf="!isNullOrEmpty(sessionModel?.httpContextIp)">
                          <div class="vid-small-label">{{"ACTIVITY.IP_ADDRESS_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1">
                            <span>{{sessionModel?.httpContextIp}}</span>
                          </div>
                        </div>

                        <div *ngIf="sessionModel?.requestTime">
                          <div class="vid-small-label">{{"ACTIVITY.REQUEST_TIME_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1">
                            <span>{{sessionModel?.requestTime | isoDateTime}}</span>
                          </div>
                        </div>

                        <div class="vid-small-label">{{"ACTIVITY.SESSION_STATUS_TITLE" | translate}}:</div>
                        <div class="vid-card-value mt-1">
                        <span *ngIf="sessionModel?.status==='COMPLETED'"
                              class="vid-badge badge bg-success">{{
                          'SESSION.COMPLETED' | translate }}</span>
                          <span *ngIf="sessionModel?.status==='FAILED'"
                                class="vid-badge badge bg-danger">{{
                            'SESSION.FAILED' | translate }}</span>
                          <span *ngIf="sessionModel?.status==='TIMEOUT'"
                                class="vid-badge badge bg-warning text-dark">{{
                            'SESSION.TIMEOUT' | translate }}</span>
                          <span *ngIf="sessionModel?.status==='CANCELED'"
                                class="vid-badge badge bg-secondary">{{
                            'SESSION.CANCELED' | translate }}</span>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div *ngIf="sessionModel?.authenticationTime">
                          <div class="vid-small-label">{{"ACTIVITY.AUTH_TIME_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1">
                            <span>{{sessionModel?.authenticationTime | isoDateTime}}</span>
                          </div>
                        </div>
                        <div *ngIf="!isNullOrEmpty(sessionModel?.authenticationResult) && sessionModel?.authenticationResult !== 'NONE'">
                          <div class="vid-small-label">{{"ACTIVITY.AUTH_RESULT_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1">
                          <span class="vid-badge badge"
                                [ngClass]="{
                                  'bg-success': sessionModel?.authenticationResult === 'AUTHENTICATED',
                                  'bg-danger': sessionModel?.authenticationResult === 'FAILED',
                                  'bg-warning text-dark': sessionModel?.authenticationResult === 'TIMEOUT',
                                  'bg-secondary': sessionModel?.authenticationResult === 'CANCELED' || sessionModel?.authenticationResult === 'NONE'
                                }">
                            {{ 'ACTIVITY.AUTHENTICATION_RESULT_STATUS_' + sessionModel?.authenticationResult | translate }}
                          </span>
                          </div>
                        </div>

                        <div
                          *ngIf="sessionModel?.authenticationMode != 'SPNEGO' && sessionModel?.authenticatorsDetails">
                          <div class="vid-small-label">{{"ACTIVITY.AUTHENTICATORS_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1">
                            <div *ngIf="sessionModel?.authenticationMode == 'SPNEGO'">
                            <span
                              class="vid-badge badge bg-primary me-2">{{'AUTHENTICATORS.SPNEGO' | translate }}
                            </span>
                            </div>
                            <div>
                            <span
                              *ngFor="let auth of sessionModel?.authenticatorsDetails.slice().reverse()"
                              class="me-2">
                              <span *ngIf="auth?.type != 'DESKTOP_FACE'">
                                <span *ngIf="auth?.status"
                                      class="vid-badge badge bg-success me-2">{{'AUTHENTICATORS.' + auth?.type | translate}}
                                </span>
                                <span *ngIf="!auth?.status"
                                      class="vid-badge badge bg-secondary me-2">{{'AUTHENTICATORS.' + auth?.type | translate}}
                                </span>
                              </span>
                            </span>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="sessionModel?.ubaMotionDetails?.score">
                          <div class="vid-small-label">{{"ACTIVITY.MOTION_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1">
                          <span class="vid-badge badge me-1"
                                [ngClass]="{ 'bg-success': sessionModel?.ubaMotionDetails.answer == 1, 'bg-danger': sessionModel?.ubaMotionDetails.answer != 1 }">{{
                            sessionModel?.ubaMotionDetails.score | number : '1.2-2'}}
                          </span>
                            <span *ngIf="!isNullOrEmpty(sessionModel?.ubaMotionDetails.answerConfidence)"
                                  class="vid-badge badge"
                                  [ngClass]="{ 'bg-primary': sessionModel?.ubaMotionDetails.answerConfidence.toLowerCase() == 'high', 'bg-secondary': sessionModel?.ubaMotionDetails.answerConfidence.toLowerCase() != 'high' }">
                            {{('UBA_DETAILS.' + sessionModel?.ubaMotionDetails.answerConfidence + '_CONFIDENCE' | uppercase) | translate}}
                          </span>
                          </div>
                        </div>

                        <div *ngIf="sessionModel?.ubaContextDetails?.score">
                          <div class="vid-small-label">{{"ACTIVITY.CONTEXT_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1">
                          <span class="vid-badge badge me-1"
                                [ngClass]="{ 'bg-success': sessionModel?.ubaContextDetails.answer == 1, 'bg-warning text-dark': sessionModel?.ubaContextDetails.answer != 1 && sessionModel?.ubaContextDetails.answerConfidence.toLowerCase() != 'high','bg-danger': sessionModel?.ubaContextDetails.answer != 1 && sessionModel?.ubaContextDetails.answerConfidence.toLowerCase() == 'high'}">{{
                            sessionModel?.ubaContextDetails.score | number : '1.2-2' }}
                          </span>
                            <span *ngIf="!isNullOrEmpty(sessionModel?.ubaContextDetails.answerConfidence)"
                                  class="vid-badge badge"
                                  [ngClass]="{ 'bg-primary': sessionModel?.ubaContextDetails.answerConfidence.toLowerCase() == 'high', 'bg-secondary': sessionModel?.ubaContextDetails.answerConfidence.toLowerCase() != 'high' }">
                            {{'UBA_DETAILS.' + (sessionModel?.ubaContextDetails.answerConfidence + '_CONFIDENCE' | uppercase) | translate}}
                          </span>
                          </div>
                        </div>

                        <div
                          *ngIf="sessionModel?.ubaContextDetails.scoreReason && getScoreReasonExplanations(sessionModel?.ubaContextDetails.scoreReason).length > 0">
                          <div class="vid-small-label">{{"ACTIVITY.CHANGES_DETECTED_TITLE" | translate}}:</div>
                          <div
                            *ngFor="let explanation of getScoreReasonExplanations(sessionModel?.ubaContextDetails.scoreReason)"
                            class="vid-card-value pb-2">
                            <span class="vid-badge badge me-1 bg-warning text-dark">{{ explanation }}</span>
                            <span tooltip="{{sessionModel?.ubaContextDetails.scoreReason[explanation]}}"><img
                              alt=""
                              src='assets/icons/view.png' width="15" height="15"></span>
                          </div>
                        </div>

                        <div
                          *ngIf="sessionModel?.ubaContextDetails.criteriaMet && getCriteriaMet(sessionModel?.ubaContextDetails.criteriaMet).length > 0">
                          <div class="vid-small-label">{{"ACTIVITY.CRITERIA_MET_TITLE" | translate}}:</div>
                          <div
                            *ngFor="let explanation of getCriteriaMet(sessionModel?.ubaContextDetails.criteriaMet)"
                            class="vid-card-value pb-2">
                            <span class="vid-badge badge me-1 bg-success">{{ explanation }}</span>
                            <span tooltip="{{sessionModel?.ubaContextDetails.criteriaMet[explanation]}}"><img
                              alt=""
                              src='assets/icons/view.png' width="15" height="15"></span>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="vid-small-label">{{"ACTIVITY.APPLICATION_TITLE" | translate}}:</div>
                        <div class="vid-card-value mt-1">
                          <span>{{sessionModel?.serviceFriendlyName || item.application}}</span>
                        </div>

                        <div>
                          <div class="vid-small-label">{{"ACTIVITY.AUTHENTICATION_DEVICE_TITLE" | translate}}:</div>
                          <div *ngIf="!isNullOrEmpty(sessionModel?.authenticationDeviceName)"
                               class="vid-card-value mt-1">
                            {{ sessionModel?.authenticationDeviceName }}
                          </div>
                          <div
                            *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.osName) || !isNullOrEmpty(sessionModel?.authCtx?.osVersion)"
                            class="vid-card-value mt-1">
                          <span
                            *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.osName)"> {{ sessionModel?.authCtx?.osName }} </span>
                            <span
                              *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.osVersion)"> {{ sessionModel?.authCtx?.osVersion }} </span>
                          </div>
                          <div
                            *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.userAgentName) || !isNullOrEmpty(sessionModel?.authCtx?.userAgentVersion)"
                            class="vid-card-value mt-1">
                          <span
                            *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.userAgentName)">{{ sessionModel?.authCtx?.userAgentName }}</span>
                            <span
                              *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.userAgentVersion)"> {{ sessionModel?.authCtx?.userAgentVersion }}</span>
                          </div>

                          <div *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.internetConnectionType)"
                               class="vid-card-value mt-1">
                            {{ sessionModel?.authCtx?.internetConnectionType }}
                          </div>

                          <div *ngIf="!isNullOrEmpty(sessionModel?.authCtx?.ip)" class="vid-card-value mt-1">
                            {{ 'IP: ' + sessionModel?.authCtx?.ip}}
                          </div>
                        </div>

                        <div>
                          <div class="vid-small-label">{{"ACTIVITY.EXPLOITER_DEVICE_STATUS_TITLE" | translate}}:</div>
                          <div class="vid-card-value mt-1"
                               *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.userAgentName) || !isNullOrEmpty(sessionModel?.exploiterCtx?.userAgentVersion)">
                          <span>
                            <span
                              *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.userAgentName)"> {{ sessionModel?.exploiterCtx?.userAgentName}} </span><span
                            *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.userAgentVersion)"> {{sessionModel?.exploiterCtx?.userAgentVersion }} </span></span>
                          </div>
                          <div
                            *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.deviceMake) || !isNullOrEmpty(sessionModel?.exploiterCtx?.deviceMake)"
                            class="vid-card-value mt-1">
                          <span
                            *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.deviceMake)"> {{ sessionModel?.exploiterCtx?.deviceMake }}</span>
                            <span
                              *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.deviceModel)"> {{ sessionModel?.exploiterCtx?.deviceModel }}</span>
                          </div>
                          <div
                            *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.osName) || !isNullOrEmpty(sessionModel?.exploiterCtx?.osVersion)"
                            class="vid-card-value mt-1">
                          <span
                            *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.osName)">{{ sessionModel?.exploiterCtx?.osName }}</span>
                            <span
                              *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.osVersion)"> {{ sessionModel?.exploiterCtx?.osVersion }}</span>
                          </div>
                          <div *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.internetConnectionType)"
                               class="vid-card-value mt-1">
                            {{ sessionModel?.exploiterCtx?.internetConnectionType }}
                          </div>
                          <div *ngIf="!isNullOrEmpty(sessionModel?.exploiterCtx?.ip)"
                               class="vid-card-value mt-1">
                            {{ 'IP: ' + sessionModel?.exploiterCtx?.ip }}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </accordion-group>
            </accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-2">
    <div class="vid-right-side-menu vid-side-menu-no-top">
      <div class="mb-2 p-2">
        <span class="section-title">{{ 'ACTIVITY.HELP' | translate }}</span>
        <div class="settings-activity">
          <div class="m-2 alert alert-secondary vid-list-item-description" role="alert">
            {{ 'ACTIVITY.HELP_SESSIONS' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
